import Layout from "../../../../Components/Common/Layout";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import MainSection from "./MainSection";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";



const CashFlow = () => {
    useNavHeading("Admin", `Vouchers`);

    return (
        <Layout title={`Vouchers | Office Flow`}>
            <DashLayout>
                <ProtectedSection requiredPermission={PERMISSIONS.VIEW_VOUCHERS} title={"Vouchers"}>
                    <MainSection />
                </ProtectedSection>

            </DashLayout>
        </Layout>
    );
}

export default CashFlow

